// Funcionalidad para la advertencia del carrito
function dismissCartWarning() {
  const warningBanner = document.querySelector('[data-cart-warning]');
  if (warningBanner) {
    // Marcar como ocultando para la animación
    warningBanner.setAttribute('data-cart-warning', 'hiding');
    
    // Ocultar después de la animación
    setTimeout(() => {
      warningBanner.setAttribute('data-cart-warning', 'hidden');
      
      // Comentado temporalmente - persistencia de 24 horas
      // localStorage.setItem('cartWarningDismissed', Date.now().toString());
    }, 300);
  }
}

// Función para verificar si la advertencia debe mostrarse
function shouldShowCartWarning() {
  // Comentado temporalmente - siempre mostrar la advertencia
  // Verificar si el usuario descartó la advertencia recientemente (en las últimas 24 horas)
  /*
  const dismissedTime = localStorage.getItem('cartWarningDismissed');
  if (dismissedTime) {
    const dismissedDate = new Date(parseInt(dismissedTime));
    const now = new Date();
    const hoursSinceDismissed = (now - dismissedDate) / (1000 * 60 * 60);
    
    // Si pasaron menos de 24 horas, no mostrar la advertencia
    if (hoursSinceDismissed < 24) {
      return false;
    }
  }
  */
  
  return true;
}

// Función para actualizar la visibilidad de la advertencia
function updateCartWarningVisibility() {
  const warningBanner = document.querySelector('[data-cart-warning]');
  if (warningBanner && !shouldShowCartWarning()) {
    warningBanner.setAttribute('data-cart-warning', 'hidden');
  }
}

// Inicialización cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Verificar si la advertencia debe mostrarse
  updateCartWarningVisibility();
  
  // Escuchar cambios en el carrito (si hay un sistema de eventos)
  if (typeof window !== 'undefined' && window.PUB_SUB_EVENTS) {
    // Si existe el sistema de eventos del tema, escuchar cambios del carrito
    document.addEventListener('cart:updated', updateCartWarningVisibility);
  }
});

// Función global para ser llamada desde Liquid
window.dismissCartWarning = dismissCartWarning;
